export function replaceTextNodeLinesWithHr(htmlString: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const walker = document.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null
  );

  while (walker.nextNode()) {
    const currentNode = walker.currentNode;

    if (currentNode.nodeValue?.includes("____________")) {
      const hrElement = document.createElement("hr");
      currentNode.parentNode?.replaceChild(hrElement, currentNode);

      walker.currentNode = hrElement;
    }
  }

  return doc.body.innerHTML;
}
